import NotFound from './redux'
export default NotFound
